import React, { Component } from "react";
import queryString from "query-string";
import { Result, Button } from "antd";

class PaymentResponsePage extends Component {
  state = {
    status: "",
    message: "",
    certificate_request_id: "",
    email: ""
  };

  componentDidMount() {
    const search = this.props.history.location.search;
    const searchData = queryString.parse(search);
    this.setState({
      status: searchData.status || "",
      message: searchData.message || "",
      certificate_request_id: searchData.certificate_request_id || "",
      email: searchData.email || ""
    });
  }

  goToPayment = () => {
    const { certificate_request_id, email } = this.state;
    if (certificate_request_id && email) {
      window.location.href = `/certificate-fees-payment?certificate_request_id=${certificate_request_id}&email=${email}`;
    } else {
      window.location.href = "/";
    }
  };

  render() {
    const { status, message } = this.state;
    const isSuccess = status === "Success";

    return (
      <div className="jumbotron">
        <div className="container">
          <div className="reg-form">
            <div className="top-bar"></div>
            <div className="form-contents">
              <h3
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center"
                }}
              >
                <div style={{ marginLeft: 0, fontWeight: 700 }}>
                  Payment Response
                </div>
              </h3>
              <hr />

              <Result
                status={isSuccess ? "success" : "error"}
                title={
                  isSuccess
                    ? "Payment successful"
                    : `Payment ${status || "failed"}`
                }
                subTitle={
                  isSuccess
                    ? "Your payment has been received. Your certificate request is now under processing."
                    : message || "Your payment was not completed."
                }
                extra={
                  <Button type="primary" onClick={this.goToPayment}>
                    {isSuccess ? "View my application" : "Try again"}
                  </Button>
                }
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PaymentResponsePage;
